<app-loader />
<router-outlet />